<app-loader />
<router-outlet />